import React from 'react';
import { SnackbarProvider } from 'notistack';
import CustomSnackbar from './CustomSnackbar';

const MAX_NOTIFICATIONS = 7;
const DEFAULT_AUTO_HIDE = 6000;

export const SnackBarProvider = ({ children, maxSnack = MAX_NOTIFICATIONS, autoHideDuration = DEFAULT_AUTO_HIDE }) => (
  <SnackbarProvider
    maxSnack={maxSnack}
    autoHideDuration={autoHideDuration}
    preventDuplicate
    Components={{
      success: CustomSnackbar,
      error: CustomSnackbar,
      warning: CustomSnackbar,
      info: CustomSnackbar
    }}>
    {children}
  </SnackbarProvider>
);
